import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BsPaperclip } from 'react-icons/bs';
import { RiFileListLine } from 'react-icons/ri';
import Tooltip from '@mui/material/Tooltip';
import iconHubsales from '../assets/logo-hubsales.png'
import categoriasJson from './categorias.json'
// ⚠️ `enviar` e `upload` saíram: os dois iam para a Octadesk e esta tela não
// usa mais nenhum. Continuam no serviço porque o `forms_gestores`
// (organização Hubsales, gente interna) ainda depende deles.
// `getOrgId` saiu (04/09): buscava a organização e o responsável NA OCTADESK a
// cada render, só para preencher ids de agente que o motor não usa. O login
// não fala mais com a Octadesk, então não há token para isso.
import { enviarNoMotor } from '../services/api.octadesk';
import Spinner from "../components/spinner/spinner";
import Whatsapp from "../components/whatsapp";
import AlertDialog from '../components/dialog';
import AccountMenu from '../components/menu-responsavel'
import Cc from "../components/cc"
import * as XLSX from 'xlsx';

import './styles.css'

function Forms(props) {

  useEffect(() => {
    document.title = "Hubdesk | Form";
  }, []);

  const [assunto, assuntoState] = useState('');
  // const [formulario, formularioState] = useState('6d7ce742-8916-4286-bac3-7657efa12259');
  const [mensagem, mensagemState] = useState('');
  const [subcategoriasOptions, subcategoriasOptionsState] = useState('');
  const [categoriaSelecionada, categoriaSelecionadaState] = useState('');
  const [categoriasOptions, categoriasOptionsState] = useState('');
  const [subcategoriaSelecionada, subcategoriaSelecionadaState] = useState('');
  const [subcategorias, subcategoriasState] = useState('');
  const [quantidade, quantidadeState] = useState('');
  const [isCadastro, isCadastroState] = useState(false);
  // 📎 O ARQUIVO EM SI (04/09). Antes só a URL da Octadesk ficava, porque o
  // upload acontecia na hora da seleção. Agora o arquivo viaja junto com a
  // abertura, então ele precisa sobreviver até o submit.
  const [arquivo, arquivoState] = useState(null);
  const [isAnexo, isAnexoState] = useState(false);
  const [isSpinner, isSpinnerState] = useState(false);
  const [fileName, fileNameState] = useState(null);
  const [modelo, modeloState] = useState(null);
  const [ticket, ticketState] = useState(null);
  const [mensagemForm, mensagemFormState] = useState(null);
  const token = sessionStorage.getItem("token");
  // const tokenRed = sessionStorage.getItem("tokenRed");
  const idOrg = sessionStorage.getItem("idOrg");
  const organization = sessionStorage.getItem("org");
  const contato = sessionStorage.getItem("nome");
  // const email = sessionStorage.getItem('email')

  const [emailsCopia, emailsCopiaState] = useState('');



  function receberDados(dados) {
    emailsCopiaState(dados)

  };

  // (04/09) sem chamada à Octadesk aqui — ver o comentário no import.

  // const call_center = () => {
  //  window.open('https://hubsales.octadesk.com/ssologin?jwttoken=' + tokenRed)
  // };
  const clearFom = () => {
    fileNameState(null);
    ticketState(null);
    modeloState(null);
    mensagemFormState(null);
    categoriasOptionsState('');
    subcategoriasOptionsState('');
    emailsCopiaState('');
    quantidadeState('');
    document.getElementById('file-upload').style.display = "flex";
    document.getElementById('file-upload').required = false;
    document.getElementById("formsSolicitacao").reset();
  }

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();

      isSpinnerState(true);

      // ⚠️ `squad` saiu junto: não se trabalha mais com squad, é área
      // (decisão de 02/09) — e ele só alimentava o roteamento removido acima.
      const userRequest = {
        "name": sessionStorage.getItem("nome"),
        "email": sessionStorage.getItem("email"),
        "idRequester": sessionStorage.getItem("idRequester")
      }

      // ⚠️ AQUI HAVIA 36 LINHAS DE ROTEAMENTO (removidas em 04/09).
      //
      // Elas mapeavam categoria → GUID de agente e de grupo DA OCTADESK
      // (`eb8b615e-…`, `2ca34450-…`) para o POST na API deles. Com o chamado
      // nascendo no nosso motor, quem roteia é a árvore dele: `categorias.area`
      // → `responsaveis` (por loja) → `areas.responsavel_padrao`, a MESMA regra
      // da fila interna.
      //
      // Removidas em vez de comentadas: código morto que calcula id de agente
      // faz o próximo leitor achar que o roteamento acontece na tela. O
      // histórico fica no git.


      // 🚪 A VIRADA (04/09): o chamado do CLIENTE nasce no NOSSO motor.
      // Os `idResponsavel`/`idGroupAssigned` calculados acima são ids de
      // agente DA OCTADESK e não viajam: o motor roteia pela árvore dele
      // (categoria → área → responsável), a mesma da fila interna.
      ticketState(await enviarNoMotor({
        assunto, mensagem, subcategoria: subcategorias,
        categoria: subcategoriaSelecionada && subcategoriaSelecionada.categoria,
        arquivo, emailsCopia, userRequest, quantidade
      }));

      isSpinnerState(false);

      // clearFom()
    } catch (error) {
      // O motor diz POR QUE recusou (403 e-mail interno, 400 categoria, 503
      // motor indisponível). Esconder isso atrás de "tente mais tarde" fez o
      // Guilherme testar com e-mail @hubsai e achar que a porta estava quebrada.
      const motivo = error && error.response && error.response.data && error.response.data.message;
      alert(motivo
        ? `⚠ Seu chamado não foi aberto: ${motivo}`
        : `⚠ Seu chamado não foi aberto❕
        Tente novamente mais tarde❕`);
      isSpinnerState(false);
      ticketState(false)
    }


  }

  var subcategoriaAux = [];

  const handleChange = (event) => {
    event.preventDefault();

    if (event.target.name === 'assunto') {

      assuntoState(event.target.value)

      // }else if(event.target.name ==='formulario'){

      //   formularioState(event.target.value)

    } else if (event.target.name === 'mensagem') {

      mensagemState(event.target.value);

    } else if (event.target.name === 'tipo') {
      isCadastroState(false);
      modeloState(null);
      mensagemFormState(null);
      categoriasOptionsState([])
      subcategoriasOptionsState([])

      let categoriaAux = [];
      if (event.target.value) {
        let categoria = categoriasJson.find(element => element.tipo === event.target.value);


        categoriaSelecionadaState(categoria.categorias);
        categoriaAux.push(<option value="" key="" >Selecione</option>);
        categoria['categorias'].forEach(function (option) {
          categoriaAux.push(
            <option value={option.categoria} key={option.categoria} >{option.categoria}</option>
          );
        });
        categoriasOptionsState(categoriaAux)
      } else {
        categoriasOptionsState([])
        subcategoriasOptionsState([])
      }
    } else if (event.target.name === 'categoria') {
      isCadastroState(false);
      modeloState(null);
      mensagemFormState(null);
      if (event.target.value) {
        let categoria = categoriaSelecionada.find(element => element.categoria === event.target.value);

        subcategoriaSelecionadaState(categoria);
        subcategoriaAux.push(<option value="" key="" >Selecione</option>);
        categoria['subcategorias'].forEach(function (option) {
          subcategoriaAux.push(
            <option value={option.id} key={option.id} >{option.nome}</option>
          );
        });
        subcategoriasOptionsState(subcategoriaAux)
      } else {
        subcategoriasOptionsState([])
      }
    } else if (event.target.name === 'subcategoria') {


      if (event.target.value) {

        let sub = subcategoriaSelecionada['subcategorias'].find(element => element.id === event.target.value)
        // console.log(sub.modelo)

        if (sub.nome === 'Cadastro de Produto') {
          isCadastroState(true)
        } else {
          isCadastroState(false)
        }
        subcategoriasState(sub);

        if (sub.mensagem) {
          mensagemFormState(sub.mensagem)
        } else {
          mensagemFormState(null)
        }

        if (sub.modelo) {
          document.getElementById('file-upload').required = true;
          modeloState(sub.modelo)
        } else {
          document.getElementById('file-upload').required = false;
          modeloState(null)
        }
      } else {
        subcategoriasState([])
        isCadastroState(false)
      }
    }

  }

  var categorias = [];
  categorias.push(<option value="" key="" >Selecione</option>);
  categoriasJson.forEach(function (option) {
    categorias.push(
      <option value={option.tipo} key={option.tipo} >{option.tipo}</option>
    );
  });

  const handleFile = async (event) => {
    try {
      document.getElementById('file-upload').style.display = "none";
      isAnexoState(true)
      let formData = new FormData()

      formData.append('file', event.target.files[0], event.target.files[0].name)
      // console.log(event.target.files[0].name)
      fileNameState(event.target.files[0].name)
      // 📎 04/09: o arquivo fica AQUI e sobe junto com a abertura. Antes ia
      // para a Octadesk na hora da SELEÇÃO, o que subia arquivo de chamado
      // que o cliente desistia de abrir.
      arquivoState(event.target.files[0])


      isAnexoState(false)
    } catch (error) {
      alert(`⚠ Erro ao anexar arquivo, 
      ou arquivo muito grande❕`)
      isAnexoState(false)
    }

  }

  const gerarModelo = () => {
    const ws = XLSX.utils.aoa_to_sheet([modelo]);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    XLSX.writeFile(wb, 'modelo ' + subcategorias.nome + '.xlsx');
  }


  return (
    <Fragment>

      <div className="navbar">

        <span className="navbar-form-title">
          <img className="iconHub" src={iconHubsales} alt="Icone Hubsales" />
          <span className="title-portal" > Portal de Atendimento</span>
          {/* <img src={iconOctadesk} alt="Icone Hubsales" /> */}
        </span>
        <div className="navbar2">
          <div className='container-button-help'>
            {/* <Tooltip title="Ver minhas solicitações." arrow>
              <a className='button-logout' type='button' href={'https://hubsales.octadesk.com/ssologin?jwttoken=' + tokenRed}
                // onClick={call_center}
              > <RiFileListLine /> <span>Solicitações</span>  </a>
            </Tooltip> */}
            {/* (04/09, noite) Meus chamados: o que ESTE e-mail abriu, lido do
                nosso backoffice — não mais da API da Octadesk. */}
            <Tooltip title="Ver e responder os seus chamados." arrow>
              <Link to="/solicitacoes" className="button-logout">
                <i><RiFileListLine /><span>Meus chamados</span></i>
              </Link>
            </Tooltip>
          </div>
          <div className='container-button-logout'>
            <AccountMenu organization={organization} contato={contato} avatar={contato.substr(0, 1)} />
            {/* <Tooltip title="Sair" arrow>
              <button className='button-logout' type='button' onClick={logout}> < CiLogout /> </button>
            </Tooltip> */}
          </div>
        </div>
      </div>
      <form id='formsSolicitacao' onSubmit={handleSubmit} className="container-forms">

        <div className="form">

          <div className="form-header">
            <div className="title">
              <h3>Abrir ticket</h3>
            </div>

          </div>

          <div className="input-group">
            <div className="input-box">

              <label htmlFor="categoria">Categoria da solicitação</label>

              <select
                className="tipo"
                id='tipo' name='tipo'
                onChange={handleChange}
                required
              >
                {categorias}
              </select>


            </div>
            {categoriasOptions.length > 1 && (
              <div className="input-box" >
                <label htmlFor="subcategorias">Categoria</label>
                <select
                  className="categorias"
                  id='categoria'
                  name='categoria'
                  onChange={handleChange}
                  defaultValue={categoriasOptions[0]}
                  required
                >
                  {categoriasOptions}
                </select>

              </div>
            )
            }
            {subcategoriasOptions.length > 1 && (
              <div className="input-box" >
                <label htmlFor="subcategorias">Subcategoria</label>
                <select
                  className="subcategorias"
                  id='subcategoria'
                  name='subcategoria'
                  onChange={handleChange}
                  defaultValue={subcategoriasOptions[0]}
                  required
                >
                  {subcategoriasOptions}
                </select>

              </div>
            )
            }
            {isCadastro && (
              <div className="input-box" >
                <label htmlFor="quantidadeSkus">Quantidade de Skus</label>

                <input
                  id="quantidadeSkus"
                  type="number"
                  name="firstname"
                  placeholder="Digite a quantidade de skus"
                  onChange={e => quantidadeState(e.target.value)}
                  required />
              </div>
            )
            }

            {mensagemForm !== null && (<div className="mensagem-modelo">
              <span> {mensagemForm}</span>

            </div>
            )}

            {modelo !== null && (
              <div className="modelo-button">
                <button type='button' className="button" onClick={gerarModelo} ><span>Gerar modelo</span>
                </button>
              </div>

            )
            }

          </div>

        </div>

        <div className="form-assunto">
          <div className='assunto emCopia'>
            <label htmlFor="copia">Cc</label>
            <Cc className="assunto-input" id='copia' name='copia' enviarEmails={receberDados} />
          </div>

          <div className="assunto">
            <label htmlFor="assunto">Assunto</label>
            <input
              className="assunto-input"
              id='assunto' name='assunto'
              onChange={handleChange}
              placeholder='Digite o título da solicitação'
              required
            />
          </div>
          <div className="mensagem">
            <label htmlFor="mensagem">Descrição</label>
            <textarea
              className="reactQuill"
              name="mensagem"
              id=""
              onChange={handleChange} type="text"
              required
            ></textarea>
          </div>
          <div className='inputFile'>

            <label htmlFor="file-upload" className="file-upload-label">
              <BsPaperclip className="file-upload-icon" />
              Anexar arquivo
              <span className='spinner-span'>{isAnexo && (<Spinner />)}</span>
            </label>
            <input
              id="file-upload"
              className="button"
              type="file"
              onChange={handleFile}
              required={mensagemForm !== null}
            />
            {fileName && (<span>{fileName}</span>)

            }

          </div>

          <div className="continue-button">
            <button className="button" type="submit"><span>Enviar</span>
              <span className='spinner-span'>{isSpinner && (<Spinner />)}</span>
            </button>
          </div>
          <div className="container-ticket">
            {ticket && (
              <div className="ticket">
                {/* <span> Seu ticket é {ticket.number}</span> */}
                {/* <span> <a href={'https://hubsales.octadesk.com/ssologin?jwttoken=' + tokenRed + '&redirect=helpcenter/history-ticket/'+ ticket.number} target="_blank" rel="noopener noreferrer"> Ver ticket {ticket.number}</a></span> */}
                <AlertDialog status="true" callbackParent={() => clearFom()} token={token} ticket={ticket.number} />
              </div>

            )}
          </div>
        </div>

      </form>
      {/* <AlertDialog /> */}
      {/* <Chat /> */}
      <Whatsapp />

    </Fragment>
  );
}

export default Forms;